import { useContext } from 'react';
import { RootContext } from '../../Context/RootContext';
//Ugly fix as I do not want to refactor our entire context setup
export const usePowermailSettings = () => {
    return useContext(RootContext).pluginContext;
};
